var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"draggableImageItem",class:_vm.picItem.actState,style:(_vm.computedPicItemStyle)},[_c('img',{attrs:{"src":_vm.picItem.urlBase64 ? _vm.picItem.urlBase64 : _vm.picItem.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }